import type { FieldMetadataMessageDescriptorDef } from './types';
import { msg } from '@lingui/core/macro';

export const locationCountryField = {
  location_country: {
    displayName: msg({
      message: 'Country',
      context: 'The display name for the country field',
    }),
    externalDescription: msg({
      message: 'The country in which the business activity took place.',
      context: 'Country',
    }),
  },
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;

export const locationFields = {
  ...locationCountryField,
  location_subdivision: {
    displayName: msg({
      message: 'State',
      context: 'The display name for the subdivision field',
    }),
  },
  location_city: {
    displayName: msg({
      message: 'City',
      context: 'The display name for the city field',
    }),
    externalDescription: msg({
      message: 'The city in which the business activity took place.',
      context: 'City',
    }),
  },
  location_grid: {
    displayName: msg({
      message: 'Electrical grid',
      context: 'The display name for the electrical grid field',
    }),
  },
  location_postal_code: {
    displayName: msg({
      message: 'Postal code',
      context: 'The display name for the postal code field',
    }),
  },
  location_street_address: {
    displayName: msg({
      message: 'Street address',
      context: 'The display name for the street address field',
    }),
  },
  location_street_address_2: {
    displayName: msg({
      message: 'Street address 2',
      context: 'The display name for the street address 2 field',
    }),
  },
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;
